export const orderList = {
  filterOrders: {
    filterTitle: 'Show orders to:',
    filterOptionTitle: 'All Subscriptions'
  },
  emptyPastOrders: {
    title: `You don’t have any orders yet`,
    description: 'Start your purchases and check this page later.',
    buttonName: 'Get Your AG1'
  },
  emptyUpcomingOrders: {
    title: 'You don’t have upcoming orders',
    buttonName: 'Get Your AG1'
  },
  upcomingOrders: {
    title: 'Upcoming Orders',
    card: {
      orderDateLabel: 'Order Date',
      subscriptionNameLabel: 'Subscription',
      subscriptionStatusLabel: 'Status',
      unpaidStatus: 'Unpaid',
      totalAmountLabel: 'Total',
      shipButton: 'Ship Now',
      editDetailsButton: 'Edit Details',
      skipShipmentButton: 'Skip Shipment'
    }
  },
  pastOrders: {
    title: 'Orders',
    table: {
      idPreSymbol: '#',
      orderNumberColumn: 'Order Number',
      dateColumn: 'Date',
      subscriptionNameColumn: 'Subscription',
      statusColumn: 'Status',
      totalColumn: 'Total',
      trackButton: 'Track Order',
      oneTimeLabel: 'One-time purchase'
    },
    card: {
      idPreSymbol: '#',
      orderLabel: 'Order',
      dateLabel: 'Date:',
      subscriptionLabel: 'Subscription',
      statusLabel: 'Status',
      totalLabel: 'Total',
      trackButtonMobile: 'Track Order',
      trackButtonTablet: 'Track Order',
      viewDetailsButton: 'View Details'
    }
  }
};
